module.exports = __webpack_public_path__ + "img/bannerRed.b7126b0b.jpg";